import React from 'react'
import styles from './Style.module.css'
import TherapistIcon from '../../../Assets/Images/no-preference.png'

const NoPreference = ({ selectNoPreference, isSelected }) => {
  return (
    <div
        key="no-preference"
        className={`
          ${styles.therapistCard} 
          ${isSelected ? styles.selected : ""}
          space-x`}
        onClick={() => selectNoPreference() }
        title="No Preference"
    >
        <img src={TherapistIcon} alt="" className={styles.icon} />
        <div className={styles.text}>
            <div>No Preference</div>
        </div>
    </div>
  )
}

export default NoPreference